<template>
  <tree-node :data="treeData"></tree-node>
</template>
<script>
import Vue from "vue";
Vue.component("tree-node", {
  props: {
    data: Object,
  },
  template: `
    <ul>
        <li>{{ data.name }}</li>
        <ul>
        <tree-node v-for="child in data.children" :data="child" :key="child.id"></tree-node>
        </ul>
    </ul>
    `,
});
export default {
  data() {
    return {
      treeData: {
        name: "Root",
        children: [
          {
            name: "Node 1",
            children: [
              {
                name: "Node 1.1",
                children: [],
              },
              {
                name: "Node 1.2",
                children: [],
              },
            ],
          },
          {
            name: "Node 2",
            children: [],
          },
        ],
      },
    };
  },
};
</script>